/* KILLA TEES EDIT
 * Preload variant colour images earlier so colour changes feel faster.
 *
 * This does NOT change variant selection, swatches, Add to Cart,
 * product IDs, or Printify data.
 */

(() => {
  let hasPreloaded = false;

  const preloadVariantImages = () => {
    if (hasPreloaded) return;
    hasPreloaded = true;

    const elements = document.querySelectorAll('[data-kt-variant-image]');

    const urls = [
      ...new Set(
        Array.from(elements)
          .map((element) => element.dataset.ktVariantImage)
          .filter(Boolean)
      ),
    ];

    urls.forEach((url) => {
      const image = new Image();

      if ('fetchPriority' in image) {
        image.fetchPriority = 'low';
      }

      image.decoding = 'async';
      image.src = url;
    });
  };

  const variantPicker = document.querySelector('variant-picker');

  if (!variantPicker || !('IntersectionObserver' in window)) {
    window.setTimeout(preloadVariantImages, 500);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        preloadVariantImages();
        observer.disconnect();
      }
    },
    {
      rootMargin: '800px 0px',
    }
  );

  observer.observe(variantPicker);
})();